/* istanbul ignore file */
export * from './ColorTile';
